export const postData = [
	{
		id: 6,
		title: "My Coursework",
		date: "31/07/2026",
		file: "coursework.md",
		tags: ["school"]
	},
	{
		id: 5,
		title: "My NUS CS Experience",
		date: "10/08/2026",
		file: "nus.md",
		tags: ["school"]
	},
	{
		id: 4,
		title: "Surviving",
		date: "19/12/2025",
		file: "surviving.md",
		tags: ["school"]
	},
	{
		id: 3,
		title: "Winter School",
		date: "08/03/2025",
		file: "winter.md",
		tags: ["school", "winter"]
	},
	{
		id: 2,
		title: "Competitive Programming",
		date: "08/03/2025",
		file: "cp.md",
		tags: ["school", "competitive programming"]
	},
	{
		id: 1,
		title: "Hello World",
		date: "09/07/2024",
		file: "helloworld.md",
		tags: ["post"]
	},
	{
		id: 0,
		title: "Test Post",
		date: "08/07/2024",
		file: "post1.md",
		tags: ["testing", "post"]
	},
]